import { ADDON_ID, TOOL_ID } from './chunk-EWHHBSJP.mjs';
import React, { useCallback, useEffect } from 'react';
import { addons, types, useGlobals, useStorybookApi } from '@storybook/manager-api';
import { IconButton } from '@storybook/components';
import { Icon } from '@storybook/components/experimental';

var Tool = () => {
  const [globals, updateGlobals] = useGlobals();
  const { measureEnabled } = globals;
  const api = useStorybookApi();
  const toggleMeasure = useCallback(
    () => updateGlobals({
      measureEnabled: !measureEnabled
    }),
    [updateGlobals, measureEnabled]
  );
  useEffect(() => {
    api.setAddonShortcut(ADDON_ID, {
      label: "Toggle Measure [M]",
      defaultShortcut: ["M"],
      actionName: "measure",
      showInMenu: false,
      action: toggleMeasure
    });
  }, [toggleMeasure, api]);
  return /* @__PURE__ */ React.createElement(
    IconButton,
    {
      key: TOOL_ID,
      active: measureEnabled,
      title: "Enable measure",
      onClick: toggleMeasure
    },
    /* @__PURE__ */ React.createElement(Icon.Ruler, null)
  );
};

// src/manager.tsx
addons.register(ADDON_ID, () => {
  addons.add(TOOL_ID, {
    type: types.TOOL,
    title: "Measure",
    match: ({ viewMode }) => viewMode === "story",
    render: () => /* @__PURE__ */ React.createElement(Tool, null)
  });
});
